import { orgBookingCount, orgTripBookList, orgTripBookToday, orgTripDrop } from '../../../api/orgTripAPI';
import errorHandle from '../../../utils/errorHandle';

export const fetchOrgBooking = (
    limit,
    setBookings,
    setStats,
    setLoading,
    offset,
    trip = '',
    selectedDate = '',
    selectedType = 'upcoming',
    datesType,
    group
) => {
    setLoading(true);
    try {
        const type = selectedType === 'upcoming' ? 'next' : 'previous';
        orgTripBookList(limit, offset, trip, selectedDate, type, datesType, group).then((res) => {
            setBookings(res.data.data);
            setStats(res.data.stats);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const getBookingsToday = (setTodaysBookings, setLoading) => {
    setLoading(true);
    try {
        orgTripBookToday().then((res) => {
            setTodaysBookings(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const getTrips = (setTrips, datesType, group, setLoading) => {
    setLoading(true);
    try {
        orgTripDrop(datesType, group).then((res) => {
            setTrips(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const bookingCount = (
    setTotalCount,
    setLoading,
    trip = '',
    selectedDate = '',
    type = 'upcoming',
    datesType,
    group
) => {
    setLoading(true);
    try {
        orgBookingCount(trip, selectedDate, type === 'upcoming' ? 'next' : 'previous', datesType, group).then((res) => {
            setTotalCount(res.data.bookCount);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
